'use es6';

import { Record } from 'immutable';
import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/EmailSubscriptions';
import { StateKeys, SUBSCRIPTION_GROUPS_INITIAL_STATE } from 'FormsUI/constants/EmailSubscriptions';
const INIT_STATE = new Record({
  [StateKeys.EMAIL_SUBSCRIPTIONS]: [],
  [StateKeys.EMAIL_SUBSCRIPTION_GROUPS]: SUBSCRIPTION_GROUPS_INITIAL_STATE,
  [StateKeys.FETCH_SUBSCRIPTIONS_REQUEST_STATE]: RequestState.NOT_REQUESTED,
  [StateKeys.FETCH_SUBSCRIPTION_GROUPS_REQUEST_STATE]: RequestState.NOT_REQUESTED
})();
export function emailSubscriptions(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_FETCH_EMAIL_SUBSCRIPTIONS:
      return state.set(StateKeys.FETCH_SUBSCRIPTIONS_REQUEST_STATE, RequestState.REQUESTED);
    case Actions.SUCCEED_FETCH_EMAIL_SUBSCRIPTIONS:
      return state.set(StateKeys.FETCH_SUBSCRIPTIONS_REQUEST_STATE, RequestState.SUCCEEDED);
    case Actions.RECEIVE_EMAIL_SUBSCRIPTIONS:
      return state.set(StateKeys.EMAIL_SUBSCRIPTIONS, action.payload);
    case Actions.FAIL_FETCH_EMAIL_SUBSCRIPTIONS:
      return state.set(StateKeys.FETCH_SUBSCRIPTIONS_REQUEST_STATE, RequestState.FAILED);
    case Actions.REQUEST_FETCH_EMAIL_SUBSCRIPTION_GROUPS:
      return state.set(StateKeys.FETCH_SUBSCRIPTION_GROUPS_REQUEST_STATE, RequestState.REQUESTED);
    case Actions.SUCCEED_FETCH_EMAIL_SUBSCRIPTION_GROUPS:
      return state.set(StateKeys.FETCH_SUBSCRIPTION_GROUPS_REQUEST_STATE, RequestState.SUCCEEDED);
    case Actions.RECEIVE_EMAIL_SUBSCRIPTION_GROUPS:
      return state.set(StateKeys.EMAIL_SUBSCRIPTION_GROUPS, action.payload);
    case Actions.FAIL_FETCH_EMAIL_SUBSCRIPTION_GROUPS:
      return state.set(StateKeys.FETCH_SUBSCRIPTION_GROUPS_REQUEST_STATE, RequestState.FAILED);
    default:
      return state;
  }
}